<template>
    <div>
        <button class="bg-[#efb536] hover:bg-transparent border border-[#e3b142] px-4 py-2 rounded font-semibold text-[#003468] hover:text-[#ffc649] transition duration-300" @click="onClickRegister">Start Service</button>
        <button class="border border-white px-4 py-2 rounded text-white font-semibold text-center hover:bg-white hover:text-blue-500 transition duration-300 tracking-wider" @click="openModal">Log In</button>

        <modal @close="closeModal" v-if="modalType" className="max-w-[32rem] w-full">
            <template #header>
                <!-- <span class="text-xl">Log In</span>&nbsp;<span class="text-sm">or <a class="no-underline" href="/register">Get an account</a></span> -->
                <span class="text-xl">Log In</span>
            </template>
            <template #body>
                <div class="pt-5 pb-3 px-4">
                    <div @keydown="clearErrors">
                        <form class="mt-2 md:mt-0 mb-2 -mx-3">
                            <div class="mb-4">
                                <label class="form-label-class" for="email">Username</label>
                                <div class="pt-1">
                                    <input class="form-input" id="email-input" ref="emailInputRef" v-model="form.email" type="text" placeholder="Username" />
                                </div>
                            </div>
                            <div>
                                <label class="form-label-class" for="password">Password</label>
                                <div class="flex flex-nowrap items-center pt-1">
                                    <input class="form-input" id="password" @keyup.enter="login" v-model="form.password" :type="passwordInputType" placeholder="Password" />
                                    <span class="cursor-pointer pl-2 pb-3" @click="togglePasswordInput">
                                        <i v-if="passwordInputType === 'password'" class="bc-glyph-eye"></i>
                                        <i v-if="passwordInputType === 'text'" class="bc-glyph-eye-slash"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="flex mt-2 mb-4">
                                <label for="termsAgreed" class="text-sm font-normal italic">
                                    <input v-model="form.termsAgreed" id="termsAgreed" type="checkbox" true-value="1" false-value="0" class="ml-1 mr-1 mb-1">
                                    I have read and agree to the <a href="/terms-of-service" target="_blank"><strong>Terms of Service</strong></a> and <a href="/terms-of-service#privacy-policy" target="_blank"><strong>Privacy Policy</strong></a>.
                                </label>
                            </div>
                            <div class="flex items-center">
                                <div>
                                    <button @click="login" class="btn btn-yellow text-lg" type="button" :disabled="submitted || form.termsAgreed == '0'">Log In</button>
                                </div>
                                <div class="mt-0">
                                    <a :href="getForgotLink()" class="no-underline text-sm font-semibold ml-3 ">Forgot Your Password?</a>
                                </div>
                            </div>
                            <div class="block mt-4">
                                <div class="text-sm text-fail font-bold" v-if="errors" v-for="error in errors">
                                    {{ error }}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'
import axios from 'axios'

const form = ref({
    email: '',
    password: '',
    remember: true,
    termsAgreed: false,
})
const errors = ref(false)
const passwordInputType = ref('password')
const modalType = ref(false)
const submitted = ref(false)
const emailInputRef = ref(null);

const onClickRegister = () => {
    if (window.location.hostname.includes('gbebinary')) {
        window.location = window.route('binary.options-register').toString();
        return;
    }

    if (window.location.hostname.includes('futureseducation')) {
        window.location = window.route('order.show-order', { orderName: 'futureseducation' }).toString();
        return;
    }

    if (window.location.pathname === '/binary/options-subscription') {
        window.location = window.route('binary.options-register').toString();
    } else {
        window.location = window.route('register').toString();
    }
}

const valid = () => {
    return false;
}

const getForgotLink = () => {
    return window.route('password.request').toString();
}

const togglePasswordInput = () => {
    passwordInputType.value = passwordInputType.value === 'password' ? 'text' : 'password';
}

const clearErrors = () => {
    errors.value = false;
}

const openModal = async () => {
    modalType.value = true;
    submitted.value = false;

    // Wait for modal to render
    await nextTick();

    // Ensure the ref is rendered in the DOM before trying to focus
    setTimeout(() => {
        if (emailInputRef.value) {
            emailInputRef.value.focus();
        }
    }, 500);  // 500ms delay
}

const closeModal = () => {
    form.value = {
        email: '',
        password: ''
    }

    modalType.value = false
}

const login = () => {
    if (form.value.termsAgreed) {
        submitted.value = true;
        clearErrors();

        const route = window.route('login');
        axios.post(route, form.value)
            .then((response) => {
                window.location = response.data.url;
            }).catch((error) => {
                submitted.value = false;
                // Display errors
                const err = error.response.data.errors;

                if (err) {
                    errors.value = Object.keys(err).map((key) => err[key][0]);
                } else {
                    errors.value = [error.response.data.message];
                }
            });
    }
}
</script>

